import type { RouterHistoryProviderProps } from '@/providers/RouterHistoryProvider';
import dynamic from 'next/dynamic';
import { SplashScreen } from './SplashScreen';

export const DynamicRegularPageLayout = dynamic(
  () => import('@/ui/Components/Layouts/RegularPageLayout').then(mod => mod.RegularPageLayout),
  {
    loading: () => <SplashScreen />,
    ssr: false,
  }
);

export const DynamicWeb3ModalProvider = dynamic(
  () => import('@/hooks/Web3ModalProvider').then(mod => mod.Web3ModalProvider),
  {
    loading: () => <SplashScreen />,
    ssr: false,
  }
);

export const DynamicSignerProvider = dynamic(
  () => import('@/hooks/wallet/SignerProvider').then(mod => mod.SignerProvider),
  {
    loading: () => <SplashScreen />,
    ssr: false,
  }
);

export const DynamicBalanceProvider = dynamic(
  () => import('@/hooks/wallet/BalanceProvider').then(mod => mod.BalanceProvider),
  {
    loading: () => <SplashScreen />,
    ssr: false,
  }
);

export const DynamicRouterHistoryProvider = dynamic<RouterHistoryProviderProps>(
  () => import('@/providers/RouterHistoryProvider').then(mod => mod.RouterHistoryProvider),
  {
    loading: () => <SplashScreen />,
    ssr: false,
  }
);

export const DynamicInitializeAsyncStorage = dynamic(
  () => import('@/ui/LifeCycle/InitializeAsyncStorage').then(mod => mod.InitializeAsyncStorage),
  { ssr: false }
);

export const DynamicOnLoadModule = dynamic(
  () => import('@/ui/LifeCycle/OnLoadModule').then(mod => mod.OnLoadModule),
  { ssr: false }
);

export const DynamicWalletConnection = dynamic(
  () => import('@/ui/LifeCycle/WalletConnectionLog').then(mod => mod.WalletConnection),
  { ssr: false }
);
